import Router from 'vue-router'

const productRouter = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      name: 'filters'
    }
  ]
})

export default productRouter
